class MatchCardHeight {
  constructor(containerSelector) {
    this.container = document.querySelector(containerSelector);
    if (!this.container) return;

    this.debouncedSync = this.debounce(this.sync.bind(this), 100);

    // Facets/sorting replace #product-grid entirely, and infinite scroll
    // appends new cards into it — resync whenever the grid changes.
    this.observer = new MutationObserver(this.debouncedSync);
    this.observer.observe(this.container, { childList: true, subtree: true });

    window.addEventListener('resize', this.debouncedSync);
    window.addEventListener('load', this.debouncedSync);

    this.sync();
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), wait);
    };
  }

  sync() {
    const grid = this.container.querySelector('#product-grid');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll(':scope > li .card-wrapper'));
    if (cards.length === 0) return;

    cards.forEach((card) => {
      card.style.minHeight = '';
    });

    const tallest = cards.reduce((max, card) => Math.max(max, card.offsetHeight), 0);

    cards.forEach((card) => {
      card.style.minHeight = `${tallest}px`;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MatchCardHeight('#ProductGridContainer');
});
